import { render, staticRenderFns } from "./swigi.vue?vue&type=template&id=5a4bcaf8&"
import script from "./swigi.vue?vue&type=script&lang=js&"
export * from "./swigi.vue?vue&type=script&lang=js&"
import style0 from "./swigi.vue?vue&type=style&index=0&id=5a4bcaf8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports